// import { Lock } from "lucide-react";
// import React, { useEffect, useState } from "react";

// const Card = ({ children, className = "", onClick }) => {
//   return (
//     <div
//       className={`rounded-lg border border-gray-200 bg-white text-gray-950 shadow-sm ${className}`}
//       onClick={onClick}
//     >
//       {children}
//     </div>
//   );
// };

// const CardContent = ({ children, className = "" }) => {
//   return <div className={`${className}`}>{children}</div>;
// };

// function LockedCard({
//   children,
//   tooltipText = "This feature is locked",
//   overlayBgColor = "",
//   buttonText = "Unlock",
//   showLockIcon = true,
// }) {
//   const [underReviewText, setUnderReviewText] = useState("");
//   const [showTooltip, setShowTooltip] = useState(false);
//   const currStep = localStorage.getItem("step");
//   const status = localStorage.getItem("status");
//   const step_status = localStorage.getItem("step_status");

//   useEffect(() => {
//     if (currStep && step_status && step_status !== "review") {
//       setUnderReviewText(
//         `This feature becomes available after all the application steps are done. Pending Step: ${currStep}.`
//       );
//     } else {
//       setUnderReviewText(
//         `Your access will be unlocked within 24-48 hours once your signed offer letter is approved.`
//       );
//     }
//   }, []);

//   return (
//     <Card className="relative shadow-xl transition-all duration-300 cursor-not-allowed overflow-visible">
//       <CardContent className="overflow-hidden rounded-lg">
//         {/* Original Card Content - Grayed Out */}
//         <div className="">{children}</div>

//         {/* Colored Overlay */}
//         <div
//           className={`absolute inset-0 bg-gray-200 opacity-40 rounded-lg z-10`}
//         ></div>

//         {/* Lock Icon with Blue Accent */}
//         {showLockIcon && (
//           <div
//             className="absolute top-3 right-3 z-[100]"
//             onMouseEnter={() => setShowTooltip(true)}
//             onMouseLeave={() => setShowTooltip(false)}
//           >
//             <div className="bg-blue-100 rounded-full p-2.5 flex items-center justify-center shadow-lg hover:bg-blue-200 transition-all hover:scale-105 relative z-[100]">
//               <Lock className="w-4 h-4 text-blue-600 cursor-not-allowed" />
//             </div>

//             {showTooltip && (
//               <div className="absolute bottom-full right-0 mb-2 px-4 py-3 bg-white  text-sm rounded-lg shadow-2xl z-[9999] w-[320px] md:w-[380px] whitespace-normal break-words">
//                 <p className="leading-relaxed">
//                   {status === "active"
//                     ? tooltipText
//                     : status === "under_review"
//                     ? step_status && currStep
//                       ? underReviewText
//                       : "Please check your application status and complete any pending steps to unlock."
//                     : "Please complete your payment to access all features."}
//                 </p>
//                 <div className="absolute top-full right-4 transform">
//                   <div className="w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-white"></div>
//                 </div>
//               </div>
//             )}
//           </div>
//         )}
//       </CardContent>
//     </Card>
//   );
// }

// export default LockedCard;

import { Lock } from "lucide-react";
import React, { useEffect, useState } from "react";

const Card = ({ children, className = "", onClick }) => {
  return (
    <div
      className={`rounded-lg border border-gray-200 bg-white text-gray-950 shadow-sm ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

const CardContent = ({ children, className = "" }) => {
  return <div className={`${className}`}>{children}</div>;
};

function LockedCard({
  children,
  tooltipText = "This feature is locked",
  overlayBgColor = "bg-white/75",
  buttonText = "Unlock",
  showLockIcon = true,
}) {
  const [underReviewText, setUnderReviewText] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const currStep = localStorage.getItem("step");
  const status = localStorage.getItem("status");
  const step_status = localStorage.getItem("step_status");

  useEffect(() => {
    if (currStep && step_status && step_status !== "review") {
      setUnderReviewText(
        `This feature becomes available after all the application steps are done. Pending Step: ${currStep}.`
      );
    } else {
      setUnderReviewText(
        `Your access will be unlocked within 24-48 hours once your signed offer letter is approved.`
      );
    }
  }, []);

  return (
    <Card className="relative border-0 shadow-xl transition-all duration-300 cursor-not-allowed overflow-visible">
      <CardContent className="overflow-hidden rounded-lg">
        {/* Original Card Content - Grayed Out */}
        <div className="opacity-50">{children}</div>

        {/* Overlay with Pattern */}
        <div
          className={`absolute inset-0 rounded-lg z-10`}
        ></div>

        {/* Lock Icon with Ring Effect */}
        {showLockIcon && (
          <div
            className="absolute top-3 right-3 z-20"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <div className="bg-white border-2 border-gray-200 rounded-full p-2.5 flex items-center justify-center shadow-md hover:border-gray-600 transition-all relative z-20">
              <Lock className="w-4 h-4 text-gray-600 cursor-not-allowed" />
            </div>

            {showTooltip && (
              <div className="absolute bottom-full right-0 mb-2 px-4 py-3 bg-white border-2 border-gray-300 text-gray-800 text-sm rounded-lg shadow-2xl z-30 w-[320px] md:w-[380px] whitespace-normal break-words">
                <p className="leading-relaxed">
                  {status === "active"
                    ? tooltipText
                    : status === "under_review"
                    ? step_status && currStep
                      ? underReviewText
                      : "Please check your application status and complete any pending steps to unlock."
                    : "Please complete your payment to access all features."}
                </p>
                <div className="absolute top-full right-4 transform">
                  <div className="w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-white"></div>
                </div>
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export default LockedCard;

// import { Lock } from "lucide-react";
// import React, { useEffect, useState } from "react";

// const Card = ({ children, className = "", onClick }) => {
//   return (
//     <div
//       className={`rounded-lg border border-gray-200 bg-white text-gray-950 shadow-sm ${className}`}
//       onClick={onClick}
//     >
//       {children}
//     </div>
//   );
// };

// const CardContent = ({ children, className = "" }) => {
//   return <div className={`${className}`}>{children}</div>;
// };

// function LockedCard({
//   children,
//   tooltipText = "This feature is locked",
//   overlayBgColor = "bg-white/60",
//   buttonText = "Unlock",
//   showLockIcon = true,
// }) {
//   const [underReviewText, setUnderReviewText] = useState("");
//   const [showTooltip, setShowTooltip] = useState(false);
//   const currStep = localStorage.getItem("step");
//   const status = localStorage.getItem("status");
//   const step_status = localStorage.getItem("step_status");

//   useEffect(() => {
//     if (currStep && step_status && step_status !== "review") {
//       setUnderReviewText(
//         `This feature becomes available after all the application steps are done. Pending Step: ${currStep}.`
//       );
//     } else {
//       setUnderReviewText(
//         `Your access will be unlocked within 24-48 hours once your signed offer letter is approved.`
//       );
//     }
//   }, []);

//   return (
//     <Card className="relative border-0 shadow-xl transition-all duration-300 cursor-not-allowed overflow-visible">
   
//       <CardContent className="overflow-hidden rounded-lg">
//         <div className="filter grayscale">{children}</div>
//         <div
//           className={`absolute inset-0 ${overlayBgColor} rounded-lg z-10`}
//         ></div>
//         {showLockIcon && (
//           <div
//             className="absolute top-3 right-4 z-[100]"
//             onMouseEnter={() => setShowTooltip(true)}
//             onMouseLeave={() => setShowTooltip(false)}
//           >
//           {/* Lock Icon with rounded gray background */}
//             {" "}
//             <div className="bg-gray-300 rounded-full p-2 flex items-center justify-center relative z-[100]">
        
//               <Lock className="w-5 h-5 text-gray-700 cursor-not-allowed" />
        
//             </div>
//             {showTooltip && (
//               <div className="absolute bottom-full right-0 mb-2 px-4 py-2 bg-gray-500 text-white text-sm rounded-lg shadow-xl z-[9999] w-[300px] md:w-[380px] whitespace-normal break-words">
           
//                 <p>
//                   {status === "active"
//                     ? tooltipText
//                     : status === "under_review"
//                     ? step_status && currStep
//                       ? underReviewText
//                       : "Please check your application status and complete any pending steps to unlock."
//                     : "Please complete your payment to access all features."}
               
//                 </p>
//                 <div className="absolute top-full right-4 transform">
                 
//                   <div className="w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-gray-500"></div>
                 
//                 </div>
//               </div>
//             )}
//           </div>
//         )}
//       </CardContent>
//     </Card>
//   );
// }

// export default LockedCard;
